/* ============================================================================
   מגירת העגלה — התאמה מלאה למראה של עמוד העגלה
   נוצר 4.8.2026.

   שלושה דברים:
     1. בשורות בנדל — פח להסרת הסט במקום הקישור "עריכה בעגלה"
     2. בשורות בנדל — מחיר אחרי הנחה + מחיר מחוק + תווית חיסכון
     3. בכל השורות — באדג' כמות על התמונה, כמו בעמוד העגלה

   ── למה קובץ נפרד ──
   את הקישור והבאדג' מרנדר pg-slider.js — 42KB. ה-API מחייב לדחוף
   קובץ שלם בכל עדכון, ולהעביר 42KB של קוד עובד עבור השינויים
   האלה הוא סיכון לא מוצדק. הקובץ הזה רץ *אחריו* ומתקן את פלט ה-DOM.

   ── התאמה לשורה ──
   לשורות במגירה אין data-bundle-id (בעמוד העגלה כן יש). מה שכן יש
   זה data-line על שדה הכמות — מספר השורה בעגלה, החל מ-1.
   לכן ההתאמה ל-cart.js נעשית לפי items[line-1].

   ── הפח ──
   משתמש ב-data-remove-bundle, שעליו pg-slider.js כבר מאזין (כולל דיאלוג
   אישור). לא משכפלים את כפתור ההסרה של התמה: המחלקה
   update-cart-btn שלו מסירה שורה בודדת, ובסט צריך להסיר הכל יחד.

   ── באדג' הכמות ──
   הערכים לא נוחשו — הם נמדדו מהבאדג' של עמוד העגלה
   (.pg-cart-qty-badge) ב-DOM החי:
       position:absolute · top:4px · right:4px · 20×20 · radius:999px
       background:#574b44 · color:#fff · font-size:11px · weight:600 · line-height:20px
   בגרסה הקודמת הבאדג' הוצב ב-top/left של מינוס 6px — כלומר מחוץ
   למסגרת התמונה ובצד ההפוך — ולכן נחתך. עכשיו הוא בתוך התמונה.

   בשורות בנדל בורר הכמות נעול (readonly — נמדד), ולכן הוא מוסתר
   והבאדג' מחליף אותו. בשורות רגילות הבורר נשאר — אחרת
   לא היתה דרך לשנות כמות מתוך המגירה.

   ── גודל המחיר ──
   בעמוד העגלה .cart__price-wrapper הוא 18px ומיושר לשמאל (נמדד).
   אותם ערכים הוחלו כאן, כולל על שורות ללא הנחה.
   ============================================================================ */
(function () {
  'use strict';

  var HOST_ID = 'bt-sidebar-cart';
  var RLM = String.fromCharCode(0x200F);

  function host() { return document.getElementById(HOST_ID); }

  function money(cents) {
    return (cents / 100).toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  function fmt(cents) {
    return RLM + money(Math.abs(cents)) + RLM + ' ₪';
  }
  function setText(el, txt) {
    if (el && el.textContent !== txt) el.textContent = txt;
  }

  function injectStyles() {
    if (document.getElementById('pg-drawer-bundle-style')) return;
    var s = document.createElement('style');
    s.id = 'pg-drawer-bundle-style';
    s.textContent =
      '#bt-sidebar-cart .pg-dr-price{display:flex;flex-wrap:wrap;align-items:baseline;gap:6px;' +
      'justify-content:flex-end;width:100%;}' +
      '#bt-sidebar-cart .pg-dr-new{font-size:18px;font-weight:600;color:var(--pg-text,#574b44);}' +
      '#bt-sidebar-cart .pg-dr-old{font-size:13px;color:var(--pg-price-old,#a79c92);text-decoration:line-through;}' +
      '#bt-sidebar-cart .pg-dr-save{font-size:12px;padding:2px 8px;border-radius:999px;' +
      'background:var(--pg-tab-header-bg,#F7E7DB);color:var(--pg-cart-accent-deep,#8a6f5e);white-space:nowrap;}' +
      '#bt-sidebar-cart .pg-set-remove{display:inline-block;font-size:16px;color:var(--pg-muted,#a79c92);' +
      'cursor:pointer;line-height:1;padding:2px;text-decoration:none;}' +
      '#bt-sidebar-cart .pg-set-remove:hover{color:var(--pg-text,#574b44);}' +
      /* באדג' הכמות — ערכים מדודים מ-.pg-cart-qty-badge שבעמוד העגלה */
      '#bt-sidebar-cart .hc__item__image{position:relative;overflow:visible !important;}' +
      '#bt-sidebar-cart .hc__item__image > a{border-radius:8px;overflow:hidden;display:block;}' +
      '#bt-sidebar-cart .pg-dr-qty{position:absolute;top:4px;right:4px;left:auto;z-index:3;' +
      'width:20px;height:20px;padding:0;border-radius:999px;' +
      'background:var(--pg-text,#574b44);color:#fff;font-size:11px;line-height:20px;' +
      'text-align:center;font-weight:600;}' +
      '#bt-sidebar-cart .hc__item[data-pg-qty-hidden="1"] .qty-box{display:none !important;}' +
      /* יישור וגודל המחיר, כמו בעמוד העגלה */
      '#bt-sidebar-cart .hc__item__price{justify-content:flex-end !important;}' +
      '#bt-sidebar-cart .hc__item__price > .w100{text-align:left !important;}' +
      '#bt-sidebar-cart .hc__item__price .money{font-size:18px;color:var(--pg-text,#574b44);}';
    document.head.appendChild(s);
  }

  function swapRemove(row, bundleId) {
    var wrap = row.querySelector('.hc__item__remove-wrap');
    if (!wrap) return;
    var note = wrap.querySelector('.pg-bundle-edit-note');
    if (note) note.parentNode.removeChild(note);
    if (wrap.querySelector('[data-remove-bundle]')) return;

    var a = document.createElement('a');
    a.className = 'pg-set-remove';
    a.setAttribute('href', '#');
    a.setAttribute('data-remove-bundle', bundleId);
    a.setAttribute('title', 'הסר את הסט');
    a.setAttribute('aria-label', 'הסר את הסט');
    var i = document.createElement('i');
    i.className = 'wicon-icons-46';
    a.appendChild(i);
    wrap.appendChild(a);
  }

  function renderPrice(row, item) {
    var priceWrap = row.querySelector('.hc__item__price');
    if (!priceWrap) return;
    var moneyWrap = priceWrap.querySelector('.w100.gutter-ele-small-top');
    if (!moneyWrap) {
      var m = priceWrap.querySelector('.money');
      moneyWrap = m ? m.parentNode : null;
    }
    if (!moneyWrap) return;

    var disc = item.line_level_total_discount || 0;
    if (disc <= 0) return;

    var box = moneyWrap.querySelector('.pg-dr-price');
    if (!box) {
      moneyWrap.textContent = '';
      box = document.createElement('span');
      box.className = 'pg-dr-price';
      var n = document.createElement('span'); n.className = 'pg-dr-new';
      var o = document.createElement('span'); o.className = 'pg-dr-old';
      var sv = document.createElement('span'); sv.className = 'pg-dr-save';
      box.appendChild(n); box.appendChild(o); box.appendChild(sv);
      moneyWrap.appendChild(box);
    }
    setText(box.querySelector('.pg-dr-new'), fmt(item.final_line_price));
    setText(box.querySelector('.pg-dr-old'), fmt(item.original_line_price));
    setText(box.querySelector('.pg-dr-save'), 'הנחה ' + fmt(disc));
  }

  function renderQty(row, item, isBundle) {
    var img = row.querySelector('.hc__item__image');
    if (!img) return;
    var qty = item.quantity || 1;

    var badge = img.querySelector('.pg-dr-qty');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'pg-dr-qty';
      img.appendChild(badge);
    }
    setText(badge, String(qty));

    var want = isBundle ? '1' : '0';
    if (row.getAttribute('data-pg-qty-hidden') !== want) {
      row.setAttribute('data-pg-qty-hidden', want);
    }
  }

  function apply(cart) {
    var h = host();
    if (!h) return;
    var rows = h.querySelectorAll('.hc__item');
    Array.prototype.forEach.call(rows, function (row) {
      var qtyEl = row.querySelector('[data-line]');
      if (!qtyEl) return;
      var line = parseInt(qtyEl.getAttribute('data-line'), 10);
      var item = cart.items[line - 1];
      if (!item) return;

      var bid = item.properties && item.properties._bundle_id;
      renderQty(row, item, !!bid);

      if (!bid) return;
      swapRemove(row, bid);
      renderPrice(row, item);
    });
  }

  var timer = null;
  function refresh() {
    if (!host()) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () { /* שקט — נשאר המבנה הקיים */ });
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 180);
  }

  function boot() {
    var h = host();
    if (!h) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (host()) { clearInterval(iv); boot(); return; }
        if (tries >= 6) clearInterval(iv);
      }, 500);
      return;
    }
    injectStyles();
    refresh();

    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(h, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-target="#bt-sidebar-cart"]') : null;
      if (t) schedule();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
